import { useProductCatalogContext } from "../ProductCatalogContext";
import { useInstallCountQuery } from "./hooks/useInstallCountQuery";
import { Skeleton } from "../../../components/loading";
import { OutlinedPaper } from "../../../components/OutlinedPaper";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { abbreviateNumber } from "../../../utils/numberUtils";

export const InstallCountCard = (props: { vendorId: number }) => {
  const { localizeInstalls, entityTypeFilterValue } =
    useProductCatalogContext();

  const { count, loading } = useInstallCountQuery(
    props.vendorId,
    localizeInstalls,
    entityTypeFilterValue
  );

  return (
    <Box width="100%">
      <OutlinedPaper>
        <Stack id="install-count" gap={1} alignItems="center" p={2}>
          <Typography variant="h4">Number of Installs</Typography>
          <Skeleton isLoading={loading} width={40} height={20}>
            <Typography variant="h2">{abbreviateNumber(count)}</Typography>
          </Skeleton>
        </Stack>
      </OutlinedPaper>
    </Box>
  );
};
